import { useContext } from 'react';
import { Link } from 'react-router-dom';
import ThemeContext from '../context/ThemeContext';
import '../styles/Terms.css';

const Terms = () => {
  const { accentColor } = useContext(ThemeContext);

  return (
    <div>
    <div className="terms-wrapper">
     <div className="terms-card">
     <div className="margdv">
        <Link className="termslink" to="/"> | Home | </Link>
      </div>
     <h1 className="terms"> Terms and Conditions</h1>
      <p className="termsp">
      EditFarmer – Terms of Service
Effective Date: 2/21/2026
Company: Const and Props, LLC
Website: https://editfarmer.com
Contact: support@editfarmer.com
<hr></hr>
1. Acceptance of Terms
By accessing this website or purchasing and downloading the Carrot Download by EditFarmer software (“Software”), you agree to these Terms of Service.
If you do not agree, please do not use the website or download the Software.
<hr></hr>
2. About EditFarmer
EditFarmer is a media automation application that assists users with:
• Playlist sequencing
• Media segment replacement
• Video and audio processing
• Workflow organization
The Software operates primarily on the user’s local machine.
<hr></hr>
3. Purchases
If you purchase a license:
• Pricing is displayed at checkout.
• Payment must be completed before download access is granted.
• Payments are processed securely by third-party payment providers.
All purchases are subject to our Refund Policy.
<hr></hr>
4. License
Your purchase grants you a limited license to use the Software in accordance with the End User License Agreement (EULA), presented during installation.
You may not:
• Copy, resell, or redistribute the Software
• Share license keys beyond authorized users
• Reverse engineer or modify the Software
<hr></hr>
5. Website Use
You agree not to:
• Attempt to interfere with website security
• Upload malicious code
• Use the website for unlawful purposes
We reserve the right to restrict access for misuse.
<hr></hr>
6. Disclaimer
The Software and website are provided “as is.”
We do not guarantee:
• Specific business or financial results
• Error-free performance
• Compatibility with all systems
Results depend on user configuration and environment.
<hr></hr>
7. Limitation of Liability
To the fullest extent permitted by law, EditFarmer is not liable for:
• Lost data
• Lost revenue
• Production delays
• Indirect or consequential damages
Total liability shall not exceed the amount paid for the Software.
<hr></hr>
8. Dispute Resolution
If a dispute arises:
1.  The parties agree to attempt informal resolution first.
2.  If unresolved, disputes shall be submitted to mediation in Washington State.
3.  If mediation fails, disputes shall be resolved by binding arbitration under the rules of the American Arbitration Association (AAA).
Disputes must be brought individually. Class actions are not permitted.
<hr></hr>
9. Governing Law
These Terms are governed by the laws of the State of Washington.
<hr></hr>
10. Contact
Const and Props, LLC
support@editfarmer.com


</p>
</div>
    </div>
    </div>
  );
};

export default Terms;
